type TimerId = number | NodeJS.Timeout

/**
 * Schedules a callback to run when the browser is idle
 * Falls back to setTimeout if requestIdleCallback is not supported
 */
export const scheduleIdleCallback = (
    callback: () => void,
    timeout: number = 100
): TimerId => {
    if ('requestIdleCallback' in window) {
        return window.requestIdleCallback(callback, {
            timeout,
        })
    }
    // Fallback for browsers that don't support requestIdleCallback
    return setTimeout(callback, timeout)
}
